import { OrderDetailsForm as OrderDetails } from './OrderDetails';
import { OrderDetailsFetcher } from './OrderDetailsFetcher';
import { useDataStore } from '@/app/core/components/step-wizard';
import { ContainerInputProps } from '@/app/features/products/common/components/input-props';
import { useEffect, useState } from 'react';
import { orderDetailsValidator } from '@ssar-app/domain';
import { Alert } from '@ssar-app/uikit';

export const OrderDetailsContainer = (props: ContainerInputProps) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys } = props;
  const { data } = useDataStore();

  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);

  return (
    <>
      {subCode !== '' && (
        <OrderDetailsFetcher
          subCode={subCode}
          onSuccess={(clientAttributes) => {
            return (
              <OrderDetails
                stepKey={keys}
                moduleProps={{
                  contactType: 'Client',
                  clientAttributes: clientAttributes,
                }}
                validator={orderDetailsValidator}
              />
            );
          }}
          onError={(error: Error) => {
            return (
              <Alert
                isOpen={true}
                showCloseButton={false}
                showIcon={false}
                description={error}
                type='error'
              />
            );
          }}
        />
      )}
    </>
  );
};
